import { LocalDate } from '@trm/datetime';
import type { BetaPageId } from '~/beta/betaPages';

export type ReleaseNote = {
  readonly id: string;
  readonly publishedOn: LocalDate.LocalDate;
  readonly title: string;
  readonly body: string;
  readonly audience: 'everyone' | 'beta';
  readonly betaPage?: BetaPageId;
};

export const releaseNotes: readonly ReleaseNote[] = [
  {
    id: '2026-10-30-beta-per-page',
    publishedOn: new LocalDate.LocalDate({ year: 2026, month: 10, day: 30 }),
    title: 'Try new pages one at a time',
    body: 'The Beta menu is gone. A page with a new version now shows a "New version in beta" tag at the top. Try it, and use "Switch to classic" on the new page whenever you want the old one back. The menu link follows your choice.',
    audience: 'beta',
  },
  {
    id: '2026-10-30-users-v2',
    publishedOn: new LocalDate.LocalDate({ year: 2026, month: 10, day: 30 }),
    title: 'New Users page',
    body: 'Search users with typed filters, choose your columns, export to CSV, and select several users to act on at once.',
    audience: 'beta',
    betaPage: 'users',
  },
  {
    id: '2026-10-30-accounts-v2',
    publishedOn: new LocalDate.LocalDate({ year: 2026, month: 10, day: 30 }),
    title: 'New Accounts page',
    body: 'Search accounts with typed filters, choose your columns, export to CSV, and select several accounts to act on at once.',
    audience: 'beta',
    betaPage: 'accounts',
  },
  {
    id: '2026-10-30-payout-details-v2',
    publishedOn: new LocalDate.LocalDate({ year: 2026, month: 10, day: 30 }),
    title: 'New Payout details page',
    body: 'The approval workflow, activity, review checks and notes for a payout, laid out in cards. Open any payout and click Try it beside the title; payouts then open in the new layout until you click Switch to classic.',
    audience: 'everyone',
    betaPage: 'payoutDetails',
  },
];
